(ns storrito.connect3.device
  "The device Storrito presents to Instagram when it connects an account,
   for the server (what connect.php sends) and for the connect3 panels
   (what the user will see in Instagram's login request)."
  (:require [clojure.string :as str]))

(def device-string
  "Device fingerprint Storrito presents to Instagram for new connects:
   Samsung Galaxy S24 + Android 15, international/Exynos.

   Also pinned to `:instagram.user/device-string` on first connect so the
   same Instagram account always reports the same device on every
   reconnect — see `storrito.connect3.instagram-client/resolve-device-string`."
  "35/15; 416dpi; 1080x2340; samsung; SM-S921B; e1q; samsungexynos2400")

(def legacy-device-string
  "Fallback for Instagram accounts that were first connected before
   `:instagram.user/device-string` existed. Those accounts logged in as
   Samsung Galaxy S20 (SM-G980F) for years — switching them to S24 now
   would look to Instagram like the device changed mid-life and risks
   triggering a security challenge."
  "31/12; 440dpi; 1080x2224; samsung; SM-G980F; x1s; exynos990")

(defn label
  "The device as Instagram's login request names it, e.g. \"Samsung
   SM-S921B\": the manufacturer and the model number of the
   device-string, not the marketing name (`str/capitalize` fits
   \"samsung\"; check it when the device-string gets another
   manufacturer). Nil for a device-string without them."
  [device-string]
  (let [[_ _ _ manufacturer model] (map str/trim (str/split (str device-string) #";"))]
    (when (and (seq manufacturer) (seq model))
      (str (str/capitalize manufacturer) " " model))))

(def pending-label
  "The label on a reconnect until the account's own device is known (a
   legacy account is not the device of a new connect, and the banner is
   already open while the label loads), and for a device-string without
   a label."
  "Samsung phone")

(def default-label
  "The label of `device-string`, for a new connect."
  (label device-string))
